const e = (o) => "color: #697a8b; ";
export {
  e as getConsoleStyle
};
//# sourceMappingURL=styledLogs.js.map
